import { useTranslation } from 'react-i18next';

import { Divider, NgButton } from '@/ui';
import { DeviceOs } from '@/signalr';
import { openHowToTurnOnGpsDialog } from './actions';

export function IncidentDetailLocationSmsSentInfo() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <Divider />
      <div className="small">
        <div>{t('IncidentDetailLocationSmsSentInfo_SmsLinkSentToCaller')}</div>
        <div>{t('IncidentDetailLocationSmsSentInfo_AfterOpeningCallerWillBeLocalized')}</div>
      </div>
      <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
        <NgButton
          icon="fa-brands fa-apple"
          outline
          size="small"
          text={t('IncidentDetailLocationSmsSentInfo_iPhoneSettingsButton')}
          onClick={() => openHowToTurnOnGpsDialog(DeviceOs.iOS)}
        />
        <NgButton
          icon="fa-brands fa-android"
          outline
          size="small"
          text={t('IncidentDetailLocationSmsSentInfo_AndroidSettingsButton')}
          onClick={() => openHowToTurnOnGpsDialog(DeviceOs.Android)}
        />
      </div>
    </div>
  );
}
